// Thông báo cho người gửi khi máy POS xác nhận / từ chối yêu cầu thu tiền thẻ
import { useEffect, useRef } from 'react';
import { notification } from 'antd';
import { METHOD_LABEL } from '../POS/data';
import { money } from '../POS/utils';
import type { PayRequest } from './data';
import useTreatmentStore from './store';
import { useTreatmentAuth } from './actions';

/**
 * Báo cho người gửi khi POS xác nhận / từ chối yêu cầu (kể cả khi đã đóng popup).
 * Bản UI-first: các tab đồng bộ qua localStorage; khi có backend thay bằng websocket / push.
 */
export function usePayRequestNotifier(onOpen?: (cardId: string) => void) {
  const requests = useTreatmentStore(s => s.payRequests);
  const { userName } = useTreatmentAuth();
  const prev = useRef<Map<string, PayRequest['status']> | null>(null);
  useEffect(() => {
    const before = prev.current;
    prev.current = new Map(requests.map(r => [r.id, r.status]));
    if (!before) return;
    requests.forEach(r => {
      if (before.get(r.id) !== 'pending' || r.status === 'pending' || r.createdBy !== userName) return;
      if (r.status === 'paid') {
        notification.success({
          key: r.id, placement: 'topRight', duration: 8,
          message: `POS đã thu ${money(r.amountPaid || r.amount)}đ`,
          description: `${r.customerName} · ${r.packageName} · ${r.installmentLabel}${r.method ? ` · ${METHOD_LABEL[r.method]}` : ''} (${r.id})`,
          onClick: () => onOpen?.(r.cardId),
        });
      } else if (r.status === 'rejected') {
        notification.error({
          key: r.id, placement: 'topRight', duration: 0,
          message: 'POS từ chối yêu cầu thu tiền',
          description: `${r.customerName} · ${money(r.amount)}đ · ${r.reason || ''} (${r.id})`,
          onClick: () => onOpen?.(r.cardId),
        });
      }
    });
  }, [requests, userName, onOpen]);
}
